// Helper de formateo regional según el idioma activo de i18next.
// Mapea el código de idioma de la app (es/en/va) a un locale tag válido
// para Intl/toLocaleString (va → "ca-ES", ya que Valencià usa reglas
// gramaticales del catalán a efectos de formato de fecha/número).

const LOCALE_TAGS = {
  es: "es-ES",
  en: "en-GB",
  va: "ca-ES",
};

export function localeTag(lang) {
  return LOCALE_TAGS[lang] || LOCALE_TAGS.es;
}

export function formatDate(date, lang, options) {
  const d = date instanceof Date ? date : new Date(date);
  return d.toLocaleDateString(localeTag(lang), options);
}

export function formatTime(date, lang, options) {
  const d = date instanceof Date ? date : new Date(date);
  return d.toLocaleTimeString(localeTag(lang), options);
}

export function formatDateTime(date, lang, options) {
  const d = date instanceof Date ? date : new Date(date);
  return d.toLocaleString(localeTag(lang), options);
}

export function formatNumber(value, lang, options) {
  return Number(value).toLocaleString(localeTag(lang), options);
}
